/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { useEffect, useRef } from "react";

/**
 * Execute a callback function on a given delay
 * @param {(function} callback
 * @param {number} delay
 */
export const useInterval = (callback, delay) => {
	// save the callback into a ref to persist the value across renders
	const savedCallback = useRef();

	// store the latest callback every time it changes
	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	// set up an interval if a delay is set, and execute the latest saved callback
	// rerun this effect only when the delay changes
	useEffect(() => {
		if (!delay) {
			return;
		}

		let id = setInterval(() => savedCallback.current(), delay);
		return () => clearInterval(id);
	}, [delay]);
};
